import I18n from 'I18n';
import { connect } from 'react-redux';
// @ts-ignore Untyped module
import { getContentTypeNounKey } from 'page-editor-ui/redux/selectors/i18nKeySelectors';
import { getIsSaveInProgress, getWasLastSaveSuccessful, getIsSavePermanentlyDisabled, getSaveState } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getHasBeenSavedOnceThisSession, getLastSaveDate, getWasLastSaveAnAutoSave
// @ts-ignore Untyped module
} from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { getIsSavingEnabled, getHasPermissionsToSave, getUnifiedSaveState
// @ts-ignore Untyped module
} from 'page-editor-ui/redux/selectors/saveSelectors';
// @ts-ignore Untyped module
import BaymaxSaveButton from 'ContentEditorUI/components/header/BaymaxSaveButton';
// @ts-ignore Untyped module
import { getHasSaveError } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
// @ts-ignore Untyped module
import { getIsReadOnlyButSlugChangeAllowedAfterDowngrades } from 'ContentEditorUI/redux/selectors/downgradeSelectors';
import { getIsUngatedForPatagonia, getIsUserJitad } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getCanUseUniversalThemeEditor } from 'page-editor-ui/redux/selectors/authSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  allowedSave: getHasPermissionsToSave(state),
  contentTypeNoun: I18n.text(getContentTypeNounKey(state)),
  hasBeenSavedOnceThisSession: getHasBeenSavedOnceThisSession(state),
  hasSaveError: getHasSaveError(state),
  isDisabled: !getIsSavingEnabled(state),
  isSaving: getIsSaveInProgress(state),
  lastSavedDate: getLastSaveDate(state),
  lastSaveSuccessful: getWasLastSaveSuccessful(state),
  permanentlyDisabled: getIsSavePermanentlyDisabled(state),
  wasLastSaveAnAutoSave: getWasLastSaveAnAutoSave(state),
  isReadOnlyButSlugChangeAllowedAfterDowngrades: getIsReadOnlyButSlugChangeAllowedAfterDowngrades(state),
  isUserJitad: getIsUserJitad(state),
  canUseUniversalThemeEditor: getCanUseUniversalThemeEditor(state),
  isUngatedForPatagonia: getIsUngatedForPatagonia(state),
  lastSave: getLastSaveDate(state),
  saveState: getSaveState(state),
  unifiedSaveState: getUnifiedSaveState(state)
});
const PageSaveButtonContainer = ({
  allowedSave,
  contentTypeNoun,
  isDisabled,
  onSaveClick,
  permanentlyDisabled,
  isUngatedForPatagonia,
  isReadOnlyButSlugChangeAllowedAfterDowngrades,
  isUserJitad,
  lastSave,
  saveState,
  unifiedSaveState,
  canUseUniversalThemeEditor,
  getUniversalThemeSupportedLastSave
}) => {
  return /*#__PURE__*/_jsx(BaymaxSaveButton, {
    allowedSave: allowedSave,
    contentTypeNoun: contentTypeNoun,
    isDisabled: isDisabled && !isReadOnlyButSlugChangeAllowedAfterDowngrades,
    onSaveClick: onSaveClick
    // TODO, we think that `permanentlyDisabled` is no longer needed and can be removed
    ,
    permanentlyDisabled: permanentlyDisabled && !isReadOnlyButSlugChangeAllowedAfterDowngrades,
    isUngatedForPatagonia: isUngatedForPatagonia,
    isUserJitad: isUserJitad,
    lastSave: canUseUniversalThemeEditor ? getUniversalThemeSupportedLastSave(lastSave) : lastSave,
    saveState: canUseUniversalThemeEditor ? unifiedSaveState : saveState
  });
};
export default connect(mapStateToProps)(PageSaveButtonContainer);